/** Repeated background ownership conflicts remain visible once per account and proof. */
import { readSession } from "./backend";
import type { Receipt } from "@/native/purchases";
const STORAGE_PREFIX = "aegae.purchaseConflict.v1:";
export async function firstPurchaseConflict(receipt: Receipt): Promise<boolean> {
  const account = readSession()?.accountId;
  if (!account) return true;
  const identity = receipt.provider === "apple" ? receipt.transaction_id : receipt.purchase_token;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(JSON.stringify([account, receipt.provider, identity])));
  const key = STORAGE_PREFIX + Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
  const first = localStorage.getItem(key) === null;
  localStorage.setItem(key, "reported");
  return first;
}
